import { create } from "zustand";
import type { components } from "@/schema";

type XperisusUser = components["schemas"]["User"];

interface AuthState {
  xperisusUser: XperisusUser | null;
  updateXperisusUser: (xperisusUser: XperisusUser | null) => void;
  clearState: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  xperisusUser: null,
  updateXperisusUser: (xperisusUser) => set({ xperisusUser }),
  clearState: () => set({ xperisusUser: null }),
}));
